import { Station } from '../types'

type ShiftStatusEnum = 'Available' | 'NotAvailable' | 'Checked'

type WeekDayEnum = 'Monday' | 'Tuesday' | 'Wednesday' | 'Thursday' | 'Friday' | 'Saturday' | 'Sunday'

type ShiftStatusType = {
  morning: ShiftStatusEnum
  evening: ShiftStatusEnum
  night: ShiftStatusEnum
  monthly: ShiftStatusEnum
}

export type ChecklistItem = {
  id: string | null | undefined
  description: string
  type: string[] | null
  shiftStatus: ShiftStatusType
  station: Station
  days: Array<WeekDayEnum>
}

export type ChecklistItemForm = ChecklistItem & { interval?: string; isContinuing?: boolean }

export const ContinuingChecklistInterval = {
  Daily: 'Daily',
  Weekly: 'Weekly',
  Monthly: 'Monthly',
}
